import toast from '@liquidweb-dev/undercurrent/toast';
import { getErrorStringHelper } from 'utility/redux/selectorHelperFunctions/apiModules';

/** @param {string} [message] */
const useSnackbarError = (message) => {
	return (error) => toast.danger(message || getErrorStringHelper(error));
};

export default useSnackbarError;
